export enum LoadingColor {
  DEFAULT = '',
  COLOR = 'color',
  WHITE = 'white',
  ORANGE = 'orange',
}

export enum LoadingType {
  DEFAULT = 'page',
  PAGE = 'page',
  INLINE = 'inline',
}
